import React, { Component } from 'react';

import Icon from '../components/Icon';

/**
 * SocialSharer
 */

export default class SocialSharer extends Component {
  constructor(props) {
    super(props);

    /** Parameters */
    const pageUrl = encodeURIComponent(document.URL);
    const title = encodeURIComponent(document.querySelector('meta[property="og:description"]').getAttribute('content'));
    this.networks = [
      {
        name: 'twitter',
        icon: 't',
        url: 'https://twitter.com/intent/tweet?url=' + pageUrl,
        params: {
          text: title,
        },
      },
      {
        name: 'facebook',
        icon: 'f',
        url: 'https://www.facebook.com/sharer.php?u=' + pageUrl,
        params: {
          p: title,
        },
      },
      {
        name: 'linkedin',
        icon: 'l',
        url: 'https://www.linkedin.com/shareArticle?mini=true&url=' + pageUrl,
      },
      {
        name: 'instagram',
        icon: 'i',
        url: 'https://www.instagram.com/?url=' + pageUrl,
        params: {
          description: title,
        },
      },
      // {
      //   name: 'pinterest',
      //   icon: 'p',
      //   url: 'https://pinterest.com/pin/create/button/?url=' + pageUrl,
      //   params: {
      //     description: title,
      //   },
      // },
      // {
      //   name: 'whatsapp',
      //   icon: 'w',
      //   url: 'https://wa.me/?text=' + pageUrl,
      // },
    ];

    /** Refs */
    this.sharer = React.createRef();
  }

  openSocialWindow(url) {
    const left = (window.screen.width - 570) / 2;
    const top = (window.screen.height - 570) / 2;
    const params = 'menubar=no,toolbar=no,status=no,width=570,height=570,top=' + top + ',left=' + left;
    window.open(url, 'NewWindow', params);
  }

  share(event, index) {
    event.preventDefault();
    let url = this.networks[index]['url'];
    const params = this.networks[index]['params'];
    for (const param in params) {
      url += '&' + param + '=' + params[param];
    }
    this.openSocialWindow(url);
  }

  render() {
    return (
      <ul ref={this.sharer} className="social-sharer">
        {this.networks.map((network, index) => (
          <li key={network.name}>
            <a href="#" onClick={(event) => this.share(event, index)}>
              <Icon icon={network.icon} />
            </a>
          </li>
        ))}
      </ul>
    );
  }
}
